/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import { API_ROOT } from 'config/hosts';
import { createRequest } from 'utils/request';
import { stringify } from 'utils/common/qs';

/* 获取永久token是的返回 */
interface PermanentTokenResp {
  access_token: string;
  openid: string;
  scope: string;
  token_type: string;
}

// TODO: 设置 header.authorization 会与 axios.interceptors.request 中的叠加导致问题，所以需要重新创建，后续如果有多个类似请求，需要移至utils/request中
const request = createRequest();

export const getPermanentToken = (token: string) => {
  const params = stringify({
    grant_type: 'permanent',
  });

  return request
    .post<PermanentTokenResp>(`${API_ROOT}/usermaster/oauth2/token.json`, params, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        authorization: `Basic ${token}`, // 此接口需要使用Basic，其他接口继续使用 Bearer
      },
    })
    .then(({ data }) => data);
};
